import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import Swal from "sweetalert2";
import {
  ExtendedRetrofitTestType,
  RetrofitService,
  RetrofitTestType,
} from "../../../../services/retrofit.service";

interface DialogData {
  testId: string;
  fileByTestType: Record<RetrofitTestType, string>;
}

interface FileResource {
  label: string;
  key: ExtendedRetrofitTestType;
}

@Component({
  selector: "app-resources-download",
  templateUrl: "./resources-download.component.html",
  styleUrls: ["./resources-download.component.css"],
})
export class ResourcesDownloadComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private retrofitService: RetrofitService,
  ) {}
  selectedTestType: RetrofitTestType = null;
  selectedFile: string = null;
  fileReources: FileResource[] = [
    {
      label: "Pre-Load (PDF)",
      key: "pre-load",
    },
    {
      label: "Post-Load (PDF)",
      key: "post-load",
    },
    {
      label: "Fast-Charge (PDF)",
      key: "fast-charge-pdf",
    },
    {
      label: "Fast-Charge (CSV)",
      key: "fast-charge",
    },
    {
      label: "On-Road (PDF)",
      key: "on-road-pdf",
    },
    {
      label: "On-Road (CSV)",
      key: "on-road",
    },
  ];

  ngOnInit(): void {}

  onResoruceChange(testType: RetrofitTestType, fileName: string) {
    this.selectedTestType = testType;
    this.selectedFile = fileName;
  }

  getPresignedPdfUrl(): void {
    const { fileByTestType } = this.data;
    const fileExists = fileByTestType[this.selectedTestType].includes(
      this.selectedFile,
    );

    if (!fileExists) {
      Swal.fire({
        title: "Oopss..",
        text: "Couldn't find the requested pdf file",
        icon: "error",
      });

      return;
    }

    this.retrofitService
      .getPresignedPdfUrl({
        fileName: this.selectedFile,
        testType: this.selectedTestType,
      })
      .subscribe((res) => {
        const { body } = res;
        if (body.success && body.data) {
          window.location.href = body.data;
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.body.message ?? "",
          });
        }
      });
  }
}
